<template>
    <v-row class="px-3" align="center" justify="space-between">
        <h1 class="subtitle-1 font-weight-bold">
            <!-- Dados de precipitação -->
            <slot name="title"></slot>
        </h1>
        <div v-show="authorizedUser && enableExportChart">
            <table-export-menu
                v-if="isTable"
                @printChart="printChart"
                @exportPDF="exportPDF"
                @exportCSV="exportCSV"
                @exportXLS="exportXLS"
            >
            </table-export-menu>
            <chart-export-menu
                v-else
                @fullscreenChart="fullscreenChart"
                @printChart="printChart"
                @exportChart="exportChart($event)"
                @exportCSV="exportCSV"
                @exportXLS="exportXLS"
                :disableItems="disableItems"
            ></chart-export-menu>
        </div>
    </v-row>
</template>

<script>
import ChartExportMenu from './ChartExportMenu.vue';
import TableExportMenu from "./TableExportMenu.vue";
export default {
    name: 'ChartHeader',
    props:{
        authorize:{
            type: Array,
            default: () => []
        },
        enableExportChart:{
            type: Boolean,
            default: true,
        },
        isTable:{
            type: Boolean,
            default: false,
        },
        disableItems:{
            type: Array,
            default: () => []
        }
    },
    components:{
        ChartExportMenu,
        TableExportMenu,
    },
    data:()=>({

    }),
    computed:{
        currentUserRoles(){
            const currentUser = this.$store.getters.currentUser;
            if(!currentUser) return [];
            const { roles } = currentUser.attributes;

            if(roles){
                const listRoles = Array.isArray(roles) ? roles : [roles];

                return listRoles;
            }

            return [];
        },
        authorizedUser(){
            return this.currentUserRoles.some(r => this.authorize.includes(r));
        }
    },
    methods:{
        exportChart(typeFile){
            this.$emit('exportChart', typeFile);
        },
        exportPDF(){
          this.$emit('exportPDF');
        },
        exportCSV(){
          this.$emit('exportCSV');
        },
        exportXLS(){
          this.$emit('exportXLS');
        },
        fullscreenChart(){
            this.$emit('fullscreenChart');
        },
        printChart(){
            this.$emit('printChart');
        },
    }
}
</script>

<style>

</style>
